"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const constants_1 = require("../../constants");
const getMessages_1 = __importDefault(require("../../actions/chats/getMessages"));
const dateFunctions_1 = require("../../utils/dateFunctions");
const stateFunctions_1 = require("../../domain/stateFunctions");
const MessagesFromSingleDay_1 = __importDefault(require("./MessagesFromSingleDay"));
const UnreadMessageDetector_1 = __importDefault(require("../../domain/UnreadMessageDetector"));
const UnreadMessagesHandler_1 = __importDefault(require("../../domain/UnreadMessagesHandler"));
const ScrollToBottomButton_1 = __importDefault(require("./ScrollToBottomButton"));
exports.default = react_1.default.memo(MessagesList);
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        position: "relative",
        overflowX: "hidden",
        overflowY: "auto"
    },
    messagesList: {
        padding: "14px 14px 0 14px"
    },
    scrollToBottomButton: {
        position: "absolute",
        bottom: 8,
        right: 24,
        zIndex: 100,
        color: theme.colors.iconAlt.color,
        backgroundColor: theme.colors.iconAlt.backgroundColor,
        "&:hover,:focus": {
            backgroundColor: theme.colors.iconAlt.hover
        }
    }
}));
function MessagesList() {
    const myUserId = react_redux_1.useSelector((state) => state.usersState.me.userId);
    const usersDictionary = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    const classes = useStyles();
    const messageIdToSelect = chat && chatFunctions.isConfirmedChat(chat) ? chat.messageToSelect : null;
    if (chat === null) {
        return react_1.default.createElement("div", null);
    }
    const isGroupChat = chatFunctions.isGroupChat(chat);
    const theirUserId = chatFunctions.isDirectChat(chat) ? chat.them : null;
    let chatId = chatFunctions.isConfirmedChat(chat) ? chat.chatId : null;
    const children = [];
    const unreadMessageDetector = new UnreadMessageDetector_1.default(chat);
    // Ignore remote messages
    const messages = chat.messages.filter(m => m.kind !== "remote");
    let messagesFromSameDay = [];
    let lastMessageDate = null;
    for (const message of messages) {
        if (lastMessageDate && !dateFunctions_1.areOnSameDay(lastMessageDate, message.date)) {
            addDay(lastMessageDate, messagesFromSameDay);
            messagesFromSameDay = [];
        }
        messagesFromSameDay.push(message);
        lastMessageDate = message.date;
    }
    if (messagesFromSameDay.length) {
        addDay(lastMessageDate, messagesFromSameDay);
    }
    function addDay(date, messages) {
        children.push(react_1.default.createElement(MessagesFromSingleDay_1.default, { chatId: chatId, key: date.toDateString(), isGroupChat: isGroupChat, myUserId: myUserId, theirUserId: theirUserId, usersDictionary: usersDictionary, messages: messages, unreadMessageDetector: unreadMessageDetector, messageIdToSelect: messageIdToSelect }));
    }
    const dispatch = react_redux_1.useDispatch();
    const messagesRef = react_1.useRef(null);
    // Start scroll listener to download more messages when scroll reaches near the top
    react_1.useLayoutEffect(() => {
        const messagesDiv = messagesRef.current;
        if (!messagesDiv || !chatFunctions.isConfirmedChat(chat)) {
            return;
        }
        // Set the scroll top or scroll bottom to maintain the previously saved scroll position
        if (chat.scrollTop !== null) {
            messagesDiv.scrollTop = chat.scrollTop;
        }
        else if (chat.scrollBottom !== null) {
            messagesDiv.scrollTop = messagesDiv.scrollHeight - messagesDiv.clientHeight - chat.scrollBottom;
        }
        const onScroll = (e) => onScroll_downloadMoreMessages(chat, e.target);
        messagesDiv.addEventListener("scroll", onScroll);
        onScroll_downloadMoreMessages(chat, messagesDiv);
        return () => messagesDiv.removeEventListener("scroll", onScroll);
    }, [chat, messagesRef.current]);
    const hasUnreadMessages = chatId
        ? chatFunctions.getUnreadMessageCount(chat) > 0
        : false;
    // Start a new UnreadMessagesHandler to mark messages as read once they have been visible for a certain duration
    react_1.useLayoutEffect(() => {
        if (!chatId || !hasUnreadMessages) {
            return;
        }
        const unreadMessagesHandler = UnreadMessagesHandler_1.default.startNew(chatId);
        return () => unreadMessagesHandler.stop();
    }, [chatId, hasUnreadMessages]);
    // If there is a messageToSelect then set the scroll so that the message is in the middle of the screen
    react_1.useLayoutEffect(() => {
        if (messageIdToSelect != null) {
            const messagesDiv = messagesRef.current;
            const clientId = chatFunctions.getClientMessageId(messages, messageIdToSelect);
            if (clientId != null && messagesDiv != null) {
                chatFunctions.scrollToMessage(messagesDiv, clientId);
            }
        }
    }, [messageIdToSelect]);
    // Listen to scroll events and load more messages if the user scrolls near the top of the currently loaded messages
    function onScroll_downloadMoreMessages(chat, messagesDiv) {
        const minMessageIdOnServer = chatFunctions.getMinMessageIdOnServer(chat);
        const downloadMoreMessages = !chat.messagesDownloading.length &&
            chat.minLocalMessageId !== null &&
            chat.minLocalMessageId > minMessageIdOnServer &&
            messagesDiv.scrollTop < 200;
        if (downloadMoreMessages) {
            const fromId = Math.max(chat.minLocalMessageId - constants_1.PAGE_SIZE, minMessageIdOnServer);
            const count = chat.minLocalMessageId - fromId;
            dispatch(getMessages_1.default(chat.chatId, fromId, count));
        }
    }
    return (react_1.default.createElement(Grid_1.default, { id: "messages", ref: messagesRef, item: true, flex: "1 1", className: classes.container },
        react_1.default.createElement("div", { className: classes.messagesList }, children),
        react_1.default.createElement(ScrollToBottomButton_1.default, { parentElem: messagesRef, className: classes.scrollToBottomButton })));
}
